import React from "react";
import { Link } from "react-router-dom";
import { EcosystemProduct } from "../data/ecosystemData";

interface ProductCardProps {
  product: EcosystemProduct;
}

/*
 * The tile from the `/` ecosystem grid (Home/section1 + sections1.css `.abc`),
 * rebuilt under homepage1- class names.
 *
 * The description is opacity: 0 rather than hidden, so it keeps its space and
 * the tile never changes height on hover — nothing below it shifts. Hovering
 * anywhere on the tile, logo or name, reveals it.
 */
export const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const isExternal = product.url.startsWith("http");
  const isHash = product.url.startsWith("#");

  const tileContent = (
    <>
      <div className="homepage1-tile-media">
        <img
          src={product.image}
          alt={`${product.name} logo`}
          className="homepage1-tile-img"
          loading="lazy"
        />
      </div>

      <span className="homepage1-tile-name">
        {product.name}
        {product.isSoon && <span className="homepage1-tile-soon">Soon</span>}
      </span>

      <span className="homepage1-tile-desc">{product.desc}</span>
    </>
  );

  if (product.isSoon || isHash) {
    return (
      <div id={product.id} className="homepage1-tile is-soon">
        {tileContent}
      </div>
    );
  }

  if (isExternal) {
    return (
      <a
        id={product.id}
        href={product.url}
        target="_blank"
        rel="noopener noreferrer"
        className="homepage1-tile"
      >
        {tileContent}
      </a>
    );
  }

  return (
    <Link to={product.url} id={product.id} className="homepage1-tile">
      {tileContent}
    </Link>
  );
};

export default ProductCard;
